import httpClient from "@/core/axios";

export default {
    namespaced: true,
    state: {
        consents: []
    },
    getters: {
        consents(state) {
            return state.consents;
        }
    },
    actions: {
        async fetch(context) {
            return httpClient
                .get("/api/guest/app/:app_uuid/user/consents")
                .then(data => context.commit("SET_CONSENTS", data));
        },
        async fetchConsent(context, { consent_id }) {
            return httpClient
                .get(`/api/guest/app/:app_uuid/user/consents/${consent_id}`)
                .then(data => context.commit("SET_CONSENTS", [data]));
        },
        async update(context) {
            return httpClient
                .patch("/api/guest/app/:app_uuid/user/consents", {
                    consents: context.state.consents
                })
                .then(data => context.commit("SET_CONSENTS", data));
        }
    },
    mutations: {
        SET_CONSENTS(state, data) {
            state.consents = data;
        },
        UPDATE_CONSENTS(state, data) {
            console.log(data);
            data = data.map(id => parseInt(id));
            state.consents.forEach(consent => {
                consent.is_granted = data.indexOf(consent.id) !== -1;
            });
        }
    }
};
